module.exports = __webpack_public_path__ + "img/nr.54af7342.svg";